import gql from 'graphql-tag';

export const UpdateUser = gql`
  mutation UpdateUser($organizationId: ID!, $userId: ID!, $request: UpdateUserRequest!) {
    updateUser(organizationId: $organizationId, userId: $userId, request: $request) {
      id
    }
  }
`;
